export default __webpack_public_path__ + "static/sBlock-80b189c6f5b6fe7deab01c44df31edb6.svg";